import { fetchStudentGoalsShared, saveStudentGoalShared } from '../shared/studentGoalsActions';
import config from '../../../configs/reading';
import StudentGoalsClientReading from '../../clients/reading/StudentGoalsClient';

export const fetchStudentGoalsReading = () => {
    return fetchStudentGoalsShared(config, StudentGoalsClientReading);
};

export const saveStudentGoalReading = goal => {
    return saveStudentGoalShared(goal, config, StudentGoalsClientReading);
};
